module.exports = __webpack_public_path__ + "static/media/nfg_logo.0230d524.jpeg";